<template>
<div style="background:#fff">
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->
        <img src="@/views/newsDetail/images/item02.png" alt="" srcset="" style="width:100%;">

    </div>
    <div class="containerOne" style="width:100%;min-height:820px;margin:45px 0 0 0">
      <div style="width:1300px;margin:0 auto">
        <!-- <img src="@/views/solution/images/group02.png" alt="" srcset="" style="width:100%;padding:30px 0 0px 0;display:block;margin-bottom:60px;"> -->
        <!-- 公共组建开始 -->
        <module-tit title="News" subTitle="新闻资讯" titleStyle="width:255px" subTitleStyle="width:1040px"/>
        <!-- 公共组件结束 -->
        <div class="one" style="text-align:center;width:100%;">
          <!-- <span style="display:block;font-size:24px;font-weight:700;padding:0 0 0px 0">
            {{contentObj.title}}
          </span>
          <span class="dateTime" style="padding:30px 0;display:block;">
            {{contentObj.create_time}}
          </span> -->
          <div class="one" style="text-align:center;width:100%;" v-html="contentObj.content"></div>
          <!-- <span class="content" style="line-height:34px;font-size:14px;text-align:left;display:block;padding:0 0 30px 0;text-indent:2em">
            优力美公司于1995年创建于中国山东莱阳，在莱阳、青岛两地分别建立起技术开发和生产基地，占地50亩，拥有先进的粉末涂料生产线和丰富生产经验的员工队伍，是中国化工学会粉末涂料涂装专业委员会的会员单位。在中国粉末涂料领域占居主导地位，成为中国山东省规模最大的专业化粉末涂料生产企业之一。本公司以“雷美”为注册商标。年生产粉末涂料6000吨以上，客户遍及家电、汽车零部件、健身器材、运输工具、金属家具、工业设备、五金工具、建筑材料等各类行业。本公司崇尚“实实在在做事，诚诚恳恳做人”的理念，确立“以人为本、追求卓越、求速创新、服务完善”的管理方针，根据客户需要定制各种颜色的亮光、平光、消光及各类花纹效果的特殊粉末涂料。 公司产品均符合欧盟ROHS指令要求、美国ASTM检测及ISO9001：2000； 纯聚酯户外粉通过国家涂料检测中心的检测、自来水管道防腐粉末涂料通过国家疾病防治中心的检测,达到饮用水及防腐标准；新开发的抑菌粉末涂料通过SGS检测，达到日本工业JIS Z 2801的标准，能够防菌灭菌，广泛应用于公共场所。公司销售市场由中国山东地区辐射到山西、福建、江苏、河北及东北地区，并直接出口美国、日本、韩国、墨西哥等十多个国家。
          </span>
           <img src="@/views/newsDetail/images/item01.png" alt="" srcset="" style="width:100%;height:600px;display:block;"> -->
        </div>

       
        
      </div>
    </div>
    <!-- <footerComponent/> -->
</div>
</template>
<script>
import moduleTit from '@/components/moduleTit'
import { getRead } from '@/api/index.js'
export default {
  name: 'App',
   components:{
    moduleTit
  },
  data() {  
    return {  
      contentObj:{}
    };  
  }, 
  mounted() {
    this.initEvent()
  },
  methods:{
    initEvent() {
      this.$nextTick(()=>{
        let _id = this.$route.query.id
        let _obj = {id:_id}
            getRead(_obj).then((res)=>{
              this.contentObj = res.data
            })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.containerOne{
  .one{
    width:100%;
    margin:0 0 50px 0
  }
}
.footWords{
  padding:20px 0;
  line-height: 30px;
}
.clearBoth {
  clear:both
}
.tit {
  margin:0 0 20px 0;
  span{
    display: block;
    padding:5px 0 10px 0;
  }
}
</style>
